import type { CSSObject } from '@emotion/react'
import { Color, FontWeight, Spacing, Typography } from '@opallabs/gem'
import { StyleProps } from '../types'

export const textStyles = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Default,
  ...Typography.M500,
  textTransform: 'none',
  flex: '1 1 auto',
  paddingInlineEnd: Spacing.S * 1.5,

  // These were in place before `Typography.M500` was added; perhaps they can
  // be removed?
  fontSize: 12,
  lineHeight: 1.5,
})

export const linkStyles = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Accent,
  fontWeight: FontWeight.Bold,
})
